// Phase 23-08: member-detail.tsx updated to use Account type (members table dropped).
// This page is accessible at /members-legacy/:id (redirected from /members/:id → /accounts/:id).
// The canonical member detail is now /accounts/:id (account-detail.tsx).
import { useParams, useLocation } from "wouter";
import { Button } from "@/components/ui/button";
import { ChevronLeft } from "lucide-react";
import {
  Breadcrumb, BreadcrumbItem, BreadcrumbList, BreadcrumbLink, BreadcrumbSeparator,
} from "@/components/ui/breadcrumb";
import { useGetAccount, getGetAccountQueryKey } from "@workspace/api-client-react";
import { MemberLedgerDrilldown } from "@/components/billing/member-ledger-drilldown";

export default function MemberDetail() {
  const params = useParams<{ id: string }>();
  const memberId = Number(params.id);
  const [, navigate] = useLocation();
  // Phase 23-08: useGetMember → useGetAccount (accounts are the canonical billable party)
  const { data: member } = useGetAccount(memberId, {
    query: {
      queryKey: getGetAccountQueryKey(memberId),
      enabled: Number.isFinite(memberId),
    },
  });

  if (!Number.isFinite(memberId)) {
    return <div className="p-6 text-muted-foreground">Invalid member id</div>;
  }

  return (
    <div className="space-y-4">
      <div className="flex items-center gap-2">
        <Button variant="ghost" size="sm" onClick={() => navigate("/accounts")}>
          <ChevronLeft className="mr-1 h-4 w-4" />
          Back to Accounts
        </Button>
      </div>
      <Breadcrumb>
        <BreadcrumbList>
          <BreadcrumbItem>
            <BreadcrumbLink onClick={() => navigate("/accounts")}>Accounts</BreadcrumbLink>
          </BreadcrumbItem>
          <BreadcrumbSeparator />
          <BreadcrumbItem>
            {member?.legalName ?? `ACC-${String(memberId).padStart(4, "0")}`}
          </BreadcrumbItem>
        </BreadcrumbList>
      </Breadcrumb>
      <MemberLedgerDrilldown memberId={memberId} />
    </div>
  );
}
